import { Component, OnInit } from '@angular/core';
import { GamesService } from 'src/app/gamification/command-center/services/games.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';

type RaffleRewardDetail = {
  editing: boolean;
  rewardType: number;
  rewardValue: number;
}

type RaffleReward = {
  isSystemReward: boolean;
  Coins: RaffleRewardDetail;
  Custom: RaffleRewardDetail & {
    rewardText: string;
  };
  XP: RaffleRewardDetail;
  Msg?: string;
};

@Component({
  selector: 'cv-raffle-rewards-details',
  templateUrl: './raffle-rewards-details.component.html',
  styleUrl: './raffle-rewards-details.component.scss'
})
export class RaffleRewardsDetailsComponent implements OnInit {
  gs = null;
  rewards: RaffleReward[] = [];

  constructor(
    private gamesService: GamesService,
    private cvLocalizationService: CVLocalizationService
  ) { 
    this.gs = this.gamesService.data;
  }

  ngOnInit(): void {
    this.rewards = this.gs?.modified?.item?.RaffleRewards || [];
  }

  isCoin(rewardValue: RaffleReward): boolean {
    return rewardValue.isSystemReward && rewardValue.Coins.rewardValue > 0;
  }

  isXP(rewardValue: RaffleReward): boolean {
    return rewardValue.isSystemReward && rewardValue.XP.rewardValue > 0;
  }

  isCustom(rewardValue: RaffleReward): boolean {
    return !rewardValue.isSystemReward && !!rewardValue.Custom.rewardText;
  }

  getRank(i: number): string {
    const index = i + 1;
    const suffixes = ['th', 'st', 'nd', 'rd'];
    const indexMod100 = index % 100;
    const suffix = suffixes[(index - 20) % 100] || suffixes[indexMod100] || suffixes[0];
    return `${index}${suffix}`;
  }

}
